import React from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Card, Drawer, Button, Col, Row } from 'antd';

import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import { AddressDisplay } from '../address_display/AddressDisplay';

import { checkAndFormatPhoneNumber } from '../../utils/DataFormatterUtils';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	ContractorPrivateNetworksRestCrudThunksForBuyer,
	ContractorPrivateNetworksRestCrudThunksForSupplier,
} from '../../thunks/contractors_private_networks_thunks';

require('./SubContractorCardDisplay.less');

class SubContractorCardDisplay extends React.Component<any, any> {
	state = {
		supplierRelationship: {},
	};
	constructor(props) {
		super(props);
		const { fetchSupplierRelationship, workOrder } = props;
		const { supplierFacilityId } = workOrder;

		fetchSupplierRelationship(supplierFacilityId).then((data) => {
			this.setState({ supplierRelationship: data && data[0] });
		});
	}

	render() {
		const { workOrder } = this.props;
		const { supplierRelationship } = this.state;

		const phoneNumbers = Array.from(
			new Set(
				[
					...(nullSafeGet('subContractorSupplierFacility.primaryPhone', workOrder)
						? [nullSafeGet('subContractorSupplierFacility.primaryPhone', workOrder)]
						: []),
					...nullSafeGetOrElse('supplierPhoneNumbers', supplierRelationship, []),
				].map((num) => checkAndFormatPhoneNumber(num))
			)
		);
		const emails = Array.from(
			new Set([
				...(nullSafeGet('subContractorSupplierFacility.primaryContactEmail', workOrder)
					? [nullSafeGet('subContractorSupplierFacility.primaryContactEmail', workOrder)]
					: []),
				...nullSafeGetOrElse('workOrdersRoutedTo', supplierRelationship, []),
			])
		);
		return (
			<div>
				<Card title="Subcontractor" hoverable={true}>
					<div className="materialCard__flexCentVert" style={{ marginBottom: 24 }}>
						<div style={{ marginRight: 16 }}>
							{nullSafeGet('subContractorSupplierFacility.logoURL', workOrder) ? (
								<FlexibleImageAvatar
									displayName={nullSafeGet('subContractorSupplierFacility.displayName', workOrder)}
									showPopover={false}
									popoverText={nullSafeGet('subContractorSupplierFacility.displayName', workOrder)}
									squareMode={true}
									width="40px"
									height="40px"
									imageUrl={nullSafeGet('subContractorSupplierFacility.logoURL', workOrder)}
								/>
							) : (
								<FlexibleImageAvatar
									displayName={nullSafeGet('subContractorSupplierFacility.displayName', workOrder)}
									showPopover={false}
									popoverText={nullSafeGet('subContractorSupplierFacility.displayName', workOrder)}
									squareMode={true}
									width="40px"
									height="40px"
									imageUrl="https://s3.amazonaws.com/emptor-data-assets/images/empty-state/icons8-city-filled-100.png"
								/>
							)}
						</div>
						<div>
							<div className="materialCard__title">
								{nullSafeGet('subContractorSupplierFacility.displayName', workOrder)}
							</div>
							<AddressDisplay
								className="materialCard__subtitle"
								hidePostcode={true}
								hideCountry={true}
								hideStreetAddress={true}
								address={nullSafeGet('subContractorSupplierFacility.primaryAddress', workOrder)}
								style={{
									color: 'rgba(0,0,0,0.45)',
								}}
							/>
						</div>
					</div>
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginTop: 16, marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-phone`} />
						</div>
						<div style={{ display: 'flex', whiteSpace: 'normal', flexWrap: 'wrap' }}>
							{phoneNumbers.map((num, i, list) => (
								<div style={{ marginRight: 4 }}>
									{checkAndFormatPhoneNumber(num)}
									{list.length - 1 > i ? ',' : null}
								</div>
							))}
						</div>
					</div>
					{nullSafeGet('subContractorSupplierFacility.primaryContactEmail', workOrder) ? (
						<div
							className="materialCard__supportingText materialCard__flexCentVert"
							style={{ marginBottom: 8 }}
						>
							<div className="materialCard__iconLabel">
								<i
									style={{ fontSize: 24 }}
									className={`icons8-font icons8-secured-letter-filled`}
								/>
							</div>
							<Col>
								{emails.map((email) => (
									<Row wrap>{email}</Row>
								))}
							</Col>
						</div>
					) : null}
				</Card>
			</div>
		);
	}
}
const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchSupplierRelationship: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? ContractorPrivateNetworksRestCrudThunksForSupplier.read({ supplierFacilityId: id })
				: ContractorPrivateNetworksRestCrudThunksForBuyer.read({ supplierFacilityId: id })
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SubContractorCardDisplay)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
